/**
 * @desc 添加费用信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.CostRequestRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/costRequest/creatCostRequest`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
